import { Common } from "../../../utils";
import { axiosBasic } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import {
  GET_BOOKMARK_LIST,
  IS_LOADING,
  TOP_TEN_LIKED_BOOKMARKS,
  GET_ACTIVE_BOOKMARK_SITES,
} from "./homePageActionsTypes";

const { UserBookmarks, LikedBookmarks, RegisterBookmarks } = config.REST_API;
const {ROOT_URL_Version_1,ROOT_URL}=config;
export const isLoading = (value) => ({
  type: IS_LOADING,
  payload: value,
});

export const bookmarkLists = (data, total) => ({
  type: GET_BOOKMARK_LIST,
  payload: { data, total },
});

export const topTenLikedbookmarks = (data, total) => ({
  type: TOP_TEN_LIKED_BOOKMARKS,
  payload: { data, total },
});

export const activebookmarksites = (data, total) => ({
  type: GET_ACTIVE_BOOKMARK_SITES,
  payload: { data, total },
});

export const onGetBookmarks = (options) => (dispatch) => {
  dispatch(isLoading(true));
  let queryString =
    "?" +
    "start=" +
    options.start +
    "&" +
    "page=" +
    options.page +
    "&take=" +
    options.limit+"&webId=18";
  axiosBasic
    .get(ROOT_URL_Version_1+UserBookmarks.Get + queryString)
    .then((response) => {
      const { success, data, message, total } = response.data;
      if (success) {
        dispatch(bookmarkLists(data, total));
      } else {
        Common.showErrorMessage(message); 
      }
    })
    .catch((error) => {
      Common.showErrorMessage(error);
    })
    .finally(() => {
      dispatch(isLoading(false));
    });
};

export const onGetTopTenLikedBookmarks = () => (dispatch) => {
  dispatch(isLoading(true));
  axiosBasic
    .get(ROOT_URL+LikedBookmarks.GetTopTenLikesBookmark)
    .then((response) => {
      const { success, data, message, total } = response.data;
      if (success) {
        dispatch(topTenLikedbookmarks(data, total));
      } else {
        Common.showErrorMessage(message);
      }
    })
    .catch((error) => {
      Common.showErrorMessage(error);
    })
    .finally(() => {
      dispatch(isLoading(false));
    });
};

export const onGetActiveBookmarkSites = () => (dispatch) => {
  dispatch(isLoading(true));
  axiosBasic
    .get(ROOT_URL+RegisterBookmarks.GetActiveBookmarkSites)
    .then((response) => {
      const { success, data, message, total } = response.data;
      if (success) {
        dispatch(activebookmarksites(data, total));
      } else {
        Common.showErrorMessage(message);
      }
    })
    .catch((error) => {
      Common.showErrorMessage(error);
    })
    .finally(() => {
      dispatch(isLoading(false));
    });
};
